export default [
  {
    id: 0,
    nome: 'À vista'
  },
  {
    id: 1,
    nome: 'A prazo - determ. (30 dias)'
  },
  {
    id: 2,
    nome: 'Parcelado'
  },
];



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-faturamento/formas-pagamento.js